import translateTextState from "./translateTextState"

export default {
  'Note.NoteBody.TranslateButton': async ({ translated, event, translation }, _, internalStateSetter) => {
    if (!translation) {
      const translatedText = await translateText(event.description)
      internalStateSetter({ translated: !translated, translation: translatedText })
    } else {
      internalStateSetter({ translated: !translated })
    }
  },
  'Note.NoteBody.Image': ({ url }, outlet) => {
    outlet({ action: 'view_media', url });
  }
}

const translateText = async (text) => {
  const r = await translateTextState.fetchDetect({ text: encodeURI(text) });
  if (!r.data?.data) return '';
  const language = r.data.data.detections[0][0].language;
  let transLang = '';
  language === 'en' ? transLang = 'es' : transLang = 'en';
  const textResponse = await translateTextState.fetchTranslate({ text: encodeURI(text), target: transLang });
  return textResponse.data.data.translations[0].translatedText;
}